package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class AutomationTestRunDetailResponse(
    val run: AutomationTestRunResponse,
    val results: List<AutomationTestResultResponse>
)
